import { Link } from 'react-router-dom'
import Copyright from '../../Utilities/Copyright'
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Copyright />
      <Link
        to="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.footerItem}
      >
        Privacy Policy
      </Link>
      <Link
        to="/cookie-policy"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.footerItem}
      >
        Cookie Policy
      </Link>
      <Link
        to="/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.footerItem}
      >
        Terms and Conditions
      </Link>
      <Link
        to="/do-not-sell"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.footerItem}
      >
        Do Not Sell or Share My Personal Information
      </Link>
    </footer>
  )
}

export default Footer
